import { memo, ReactNode } from "react";
import { Table } from "semantic-ui-react";

// Utils
import moment from "moment";

// Component
import BroadcastStatusBadge from "./BroadcastStatusBadge";
import BroadcastPreviewCell from "./BroadcastPreviewCell";
import BroadcastActionMenu from "./BroadcastActionMenu";

// Types
import { BroadcastAction } from "./MeCastType";

// Serializers
import BroadcastPostSerializer from "@/issara-sdk/types/BroadcastPostSerializer_apps_PRX";

type PreviewData = {
  text: string;
  media: string | null;
};

type BroadcastTableRowProps = {
  row: BroadcastPostSerializer;
  preview: PreviewData;
  actions: BroadcastAction[];
  isActionOpen: boolean;
  onToggleAction: () => void;
  onAction: (action: BroadcastAction) => void;
};

const formatScheduleDate = (row: BroadcastPostSerializer): string | ReactNode => {
  const { broadcast_type, status, broadcasted_at, schedule_broadcasted_at } = row;

  if (broadcast_type === "INSTANTLY") {
    if (status === "BROADCASTED") {
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>{moment(broadcasted_at).format("DD/MM/YYYY \\[HH:mm\\]")}</label>
          <label style={{ color: "#888", fontSize: "0.9em" }}>(Sent Instantly)</label>
        </div>
      );
    }
    return "Sent Instantly";
  }

  if (broadcast_type === "SCHEDULE") {
    if (status === "BROADCASTED") {
      return (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label>
            {schedule_broadcasted_at
              ? moment(schedule_broadcasted_at).format("DD/MM/YYYY \\[HH:mm\\]")
              : "-"}
          </label>
          <label style={{ color: "#888", fontSize: "0.9em" }}>(Schedule)</label>
        </div>
      );
    }

    return schedule_broadcasted_at
      ? moment(schedule_broadcasted_at).format("DD/MM/YYYY \\[HH:mm\\]")
      : "-";
  }

  return "-";
};

const formatGroupName = (row: BroadcastPostSerializer): string => {
  if (row.group_name) return row.group_name;
  if (row.receiver_type === "ALL_MEMBER") return "All members";
  return "-";
};

const BroadcastTableRow = (props: BroadcastTableRowProps) => {

  return (
    <Table.Row>
      <Table.Cell>{props.row.broadcast_id}</Table.Cell>
      <Table.Cell>
        <BroadcastPreviewCell preview={props.preview} />
      </Table.Cell>
      <Table.Cell>{formatGroupName(props.row)}</Table.Cell>
      <Table.Cell>{formatScheduleDate(props.row)}</Table.Cell>
      <Table.Cell>
        <BroadcastStatusBadge status={props.row.status} label={props.row.status_custom_label} />
      </Table.Cell>
      <Table.Cell style={{ textAlign: "center" }}>{props.row.total_member_count}</Table.Cell>
      <Table.Cell
        style={{
          position: "relative",
          fontSize: "20px",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        <span onClick={props.onToggleAction}>...</span>
        {props.isActionOpen && (
          <BroadcastActionMenu actions={props.actions} onAction={props.onAction} />
        )}
      </Table.Cell>
    </Table.Row>
  );
};

export default memo(BroadcastTableRow);
